export default {
    header: "Benefits for Employers",
    subHeader: "Companies benefit from apprentice programs.",
    firstSectionGeneralText: "Connect with diverse talent. Develop that talent to close skill gaps and fuel innovation. Demonstrate leadership for the future of work. It's all possible through apprenticeship.",
    sourceDOL: "https://www.dol.gov",
    sourceNA: "https://nationalapprenticeship.org"
}